import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const BookingFormComponent = (props) => {
  useEffect(() => {
    // Cargar el script solo una vez cuando se monta el componente
    const script = document.createElement('script');
    script.src = 'https://bookingform.sandos.com/js/main.js';
    script.type = 'text/javascript';
    script.async = true;

    document.body.appendChild(script);

    // Cleanup opcional si necesitas removerlo al desmontar
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const isMobile = window.innerWidth <= 768;
  const formMode = isMobile? "embedded": "topbar";
  return (
    <div style={isMobile ? {} : { top: '50px' }} className={`fixed mt-12 py-2 inset-x-0 top-0 bg-white shadow-lg z-50 ${props.show ? "show" : "hidden"}`}>
      <link rel="stylesheet" href="https://bookingform.sandos.com/css/main.css" />
      <div
        id="bookingForm"
        data-lang={props.locale}
        data-formmode={formMode}
        data-origin="CORP"
        data-force-booking-visible={true}
      ></div>
    </div>
  );
};

BookingFormComponent.propTypes = {
  show: PropTypes.bool,
  locale: PropTypes.string,
}

export default BookingFormComponent;